import { ICartEntry, MinimalCartEntryType } from 'features/cart/types';
import { StyleSheet, View } from 'react-native';

import { primitive } from 'styles/constants/primitives';

import { CartEntryBody } from './cart-entry-body';
import { CartEntryFooter } from './cart-entry-footer';
import { CartEntryHeader } from './cart-entry-header';

export const CartEntry = ({ cartEntry }: { cartEntry: ICartEntry }) => {
  const showCartEntry =
    cartEntry.type === MinimalCartEntryType.combo ||
    cartEntry.type === MinimalCartEntryType.item ||
    cartEntry.type === MinimalCartEntryType.incentive ||
    cartEntry.type === MinimalCartEntryType.reward;

  if (!showCartEntry) {
    return null;
  }
  return (
    <View style={styles.container}>
      <CartEntryHeader cartEntry={cartEntry} />
      <CartEntryBody cartEntry={cartEntry} />
      <CartEntryFooter cartEntry={cartEntry} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'column',
    backgroundColor: primitive.bk.$white,
    borderRadius: 10,
  },
  header: {
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    flexDirection: 'row',
    gap: 10,
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 14,
    borderBottomWidth: 1,
    borderBottomColor: primitive.$blackOpacity10,
  },
  footer: {
    flexDirection: 'row',
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderTopWidth: 1,
    borderTopColor: primitive.$blackOpacity10,
    alignItems: 'center',
    gap: 16,
  },
  item: {
    flexDirection: 'row',
    gap: 12,
    alignItems: 'center',
    flex: 1,
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderBottomWidth: 1,
    borderBottomColor: primitive.$blackOpacity10,
  },
  editText: {
    fontSize: 14,
    fontWeight: 'bold',
    fontFamily: primitive.fontFamily.$headers,
    color: primitive.bk.$bbqBrown,
  },
});
